// eslint-disable-next-line no-restricted-imports
import { useDispatch } from "react-redux";
import type { AppDispatch } from "./index";

export const useAppDispatch = () => useDispatch<AppDispatch>();
